<template>
  <b-sidebar
    id="service-modal"
    v-model="isVisible"
    class="px-3 py-2"
    bg-variant="white"
    width="540px"
    right
    backdrop
    shadow
    no-header
  >
    <div class="sidebar-container">
      <dx-scroll-view>
        <header class="d-flex justify-content-end">
          <dx-button
            :text="$t('Close')"
            class="close-text-button"
            icon="ace-icon icon-close"
            @click="isVisible = false"
          />
        </header>
        <b-row class="mb-2">
          <b-col>
            <h2>
              {{ $t('Services') }}
            </h2>
          </b-col>
        </b-row>
        <dx-list
          ref="freightServicesGrid"
          class="mb-4"
          :data-source="services"
          :show-selection-controls="true"
          selection-mode="selectionMode"
          :select-by-click="selectByClick"
          display-expr="description"
          :selected-item-keys.sync="innerSelectedServices"
        >
          <dx-selection
            show-check-boxes-mode="always"
            mode="multiple"
          />
        </dx-list>
        <div class="d-flex flex-row mb-1 justify-content-around">
          <dx-button
            :text="$t('Cancel')"
            type="success"
            styling-mode="text"
            class="custom-btn"
            width="180"
            @click="isVisible = false"
          />

          <dx-button
            :text="$t('Add')"
            type="success"
            styling-mode="contained"
            class="custom-btn"
            width="280"
            @click="submit"
          />
        </div>
      </dx-scroll-view>
    </div>
  </b-sidebar>
</template>

<script>
import { mapState } from 'vuex';
import { DxButton } from 'devextreme-vue';
import DxList from 'devextreme-vue/list';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import {
  DxSelection,
} from 'devextreme-vue/data-grid';

export default {
  name: 'AutocompleteModal',
  components: {
    DxButton,
    DxSelection,
    DxList,
    DxScrollView,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    services: Array,
    selectedServices: Array,
    serviceTransportTypes: Array,
    serviceShipmentTypes: Array,
  },
  data: () => ({
    innerSelectedServices: [],
    selectByClick: false,
  }),
  computed: {
    ...mapState(['user']),
    // closeButtonOptions() {
    //   return {
    //     text: 'Закрыть',
    //     icon: 'close',
    //     class: 'close-text-button',
    //     onClick: () => {
    //       this.isVisible = false;
    //     },
    //   };
    // },
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
    this.innerSelectedServices = this.selectedServices.map(({ id }) => id);
  },
  methods: {
    submit() {
      this.$emit('submit', this.innerSelectedServices.map(({ id }) => id));
      this.isVisible = false;
    },
    customizeTransportText(cellInfo) {
      return cellInfo.value.map(it => this.serviceTransportTypes.find(({ id }) => it === id).description).join(', ');
    },
    customizeShipmentText(cellInfo) {
      return cellInfo.value.map(it => this.serviceShipmentTypes.find(({ id }) => it === id).description).join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>

  // .dx-datagrid {
  //   .dx-datagrid .dx-row-lines > td {
  //     border-bottom: none !important;
  //   }
  // }

  .sidebar-container {
    padding: 32px;
    header {
      margin-bottom: 25vh;
    }
  }

  .close-text-button {
    width: fit-content;
    color: #3C5AC3;
    background-color: white;
    box-shadow: none;
    &:hover {
      color: #2347C6;
      background-color: white;
      box-shadow: none;
    }
    &:active,
    &:focus {
      color: #3C5AC3;
      border: 2px solid #3C5AC3;
      background-color: white;
      box-shadow: none;
      transition: all 0.2s;
    }
  }

</style>
